const ReportingReasons = {
  NOT_HELPFUL: {
    label: 'Informatie is niet strikt gerelateerd aan de zoekopdracht / niet behulpzaam',
  },
  INACCURATE: {
    label: 'Verstrekte informatie is onnauwkeurig',
  },
  BIASED: {
    label: 'Verstrekte informatie is bevooroordeeld',
  },
  OFFENSIVE: {
    label: 'Verstrekte informatie is aanstootgevend',
  },
  OTHER: {
    label: 'Anders (gelieve te specificeren)',
  },
};

export default ReportingReasons;
